/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    17/06/2018
 */
export class PostalCode {
    public id: string;
    public code: string;
    public village: Village;
}

export class Village {
    public id: string;
    public name: string;
    public subDistrict: SubDistrict;
}

export class SubDistrict {
    public id: string;
    public name: string;
    public city: City;
}

export class City {
    public id: string;
    public name: string;
    public district: boolean;
    public province: Province | null;
}

export class Province {
    public id: string;
    public name: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/common/domains/models/addressing.ts